import createModel, { prop } from '../lib/create_model';

export default createModel({
  modelName: 'ChatAddressContent',
  properties: {
    isAuthenticated: prop(Boolean).isRequired,
    createdAt: prop(String).isRequired,
  },
});
